import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

// Client-side paginator for profile relationship sections — each instance pages independently.
// Page size comes from admin Appearance settings via perKey, falling back to perDefault.
export function Paged({ items = [], perKey, perDefault = 6, per, label = "items", render, testid = "paged-section" }) {
  const { settings } = useSettings();
  const [p, setP] = useState(1);
  const fromSettings = perKey ? parseInt(settings?.[perKey], 10) : NaN;
  const effPer = per || (Number.isFinite(fromSettings) && fromSettings >= 1 && fromSettings <= 50 ? fromSettings : perDefault);
  const total = items.length;
  const pages = Math.max(1, Math.ceil(total / effPer));
  const page = Math.min(p, pages);
  const start = (page - 1) * effPer;
  const slice = items.slice(start, start + effPer);
  return (
    <div data-testid={testid}>
      {render(slice)}
      {total > effPer && (
        <div className="flex items-center justify-between mt-4 text-sm">
          <span className="text-zinc-500 text-xs" data-testid={`${testid}-count`}>
            Showing {start + 1}-{Math.min(start + effPer, total)} of {total} {label}
          </span>
          <div className="flex items-center gap-1.5">
            <button onClick={() => setP(page - 1)} disabled={page <= 1} data-testid={`${testid}-prev`}
              className="p-1.5 rounded-lg border border-white/10 text-zinc-400 hover:text-white disabled:opacity-30"><ChevronLeft size={15} /></button>
            <span className="text-xs text-zinc-500">{page} / {pages}</span>
            <button onClick={() => setP(page + 1)} disabled={page >= pages} data-testid={`${testid}-next`}
              className="p-1.5 rounded-lg border border-white/10 text-zinc-400 hover:text-white disabled:opacity-30"><ChevronRight size={15} /></button>
          </div>
        </div>
      )}
    </div>
  );
}
